import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { SoundsActions } from "./sounds.actions";

export interface SoundsStateModel {
    systemVolume: number;
}

@State<SoundsStateModel>({
    name: "sounds",
    defaults: {
        systemVolume: 1,
    },
})
@Injectable()
export class SoundsState {
    @Selector()
    public static systemVolume(state: SoundsStateModel) {
        return state.systemVolume;
    }

    @Action(SoundsActions.SetVolume)
    public setSystemVolume(context: StateContext<SoundsStateModel>, action: SoundsActions.SetVolume): void {
        context.patchState({ systemVolume: action.volume });
    }
}
